module.exports = __webpack_public_path__ + "img/jnv.d9abe71d.svg";